export default "__VITE_ASSET__C6dY3PY4__"